import { Seeder } from '../seeder'
import { bsConstants } from '../../module.constants'
import { LiveSeedPenNames, SeedPenName, SeedPenNames } from './interfaces'
import { SeedCategories } from '../../seeder.constants'
import { UserSeeder } from '../user'

const userSeeder = new UserSeeder()
const seedUsers = { ...userSeeder.getLiveDataObject(), ...userSeeder.getTestDataObject() }

export class PenNameSeeder extends Seeder<SeedPenNames, {}, SeedPenName> {
  type = 'penName'
  maxModelCount = 40

  base = {
    categoryId: SeedCategories.SpeculativeFiction_ScienceFiction.id,
    wordCount: 1,
    audience: 1,
    preview: 'A long time ago in a galaxy far far away ...',
    penNameType: bsConstants.PEN_NAME.TYPE.PUBLISHING
  }

  getLiveDataObject (): LiveSeedPenNames {
    return {
      DeletedPenName: {
        id: 1,
        name: '[Deleted Author]',
        image: '',
        userId: seedUsers.DeletedUser.id
      }
    }
  }

  getTestDataObject (): SeedPenNames {
    if (process.env.BUILD_MODE === 'master') {
      return {} as unknown as SeedPenNames
    }

    const testData = {
      TimothyZahn: {
        id: this.getNextId(),
        name: 'Timothy Zahn',
        image: 'TimothyZahn.jpg',
        userId: seedUsers.Me.id,
        addFollowers: [seedUsers.Me.id, seedUsers.OldBsUser.id]
      },
      DrewKarpyshyn: {
        id: this.getNextId(),
        name: 'Drew Karpyshyn',
        image: 'DrewKarpyshyn.jpg',
        userId: seedUsers.Publisher.id,
        addFollowers: [seedUsers.Me.id, seedUsers.DarthVadar.id, seedUsers.Thrawn.id]
      },
      FollowingAuthor: {
        id: this.getNextId(),
        name: 'Following Author',
        image: 'test.png',
        userId: seedUsers.Me.id,
        addFollowers: [seedUsers.StanRizzo.id]
      },
      GeneralAuthor: {
        id: this.getNextId(),
        name: 'General Author',
        image: 'test.png',
        userId: seedUsers.Me.id,
        addFollowers: [
          seedUsers.StanRizzo.id,
          seedUsers.NotificationTopReviewer.id,
          seedUsers.PostmarkTransientBounce.id,
          seedUsers.PostmarkSoftBounce.id,
          seedUsers.PostmarkDnsError.id
        ],
        facebookLink: 'https://www.facebook.com',
        bookbubLink: 'https://www.bookbub.com',
        twitterLink: 'https://www.twitter.com',
        instagramLink: 'https://www.instagram.com'
      },
      NotificationAuthor: {
        id: this.getNextId(),
        name: 'Notification Author',
        image: 'test.png',
        userId: seedUsers.NotificationAuthor.id,
        addFollowers: [
          seedUsers.NotificationReviewer.id,
          seedUsers.NotificationReviewerNoOtherLanguages.id
        ],
        facebookLink: 'https://www.facebook.com',
        bookbubLink: 'https://www.bookbub.com',
        twitterLink: 'https://www.twitter.com',
        instagramLink: 'https://www.instagram.com'
      },
      GrowingAuthor: {
        id: this.getNextId(),
        name: 'Growing Author',
        image: 'test.png',
        userId: seedUsers.GrowingAuthor.id,
        facebookLink: 'https://www.facebook.com',
        bookbubLink: 'https://www.bookbub.com',
        twitterLink: 'https://www.twitter.com',
        instagramLink: 'https://www.instagram.com'
      },
      ProAuthor: {
        id: this.getNextId(),
        name: 'Pro Author',
        image: 'test.png',
        userId: seedUsers.ProAuthor.id,
        facebookLink: 'https://www.facebook.com',
        bookbubLink: 'https://www.bookbub.com',
        twitterLink: 'https://www.twitter.com',
        instagramLink: 'https://www.instagram.com'
      },
      PenNameForRandomArcs: {
        id: this.getNextId(),
        name: 'Pen name for random arcs',
        image: 'test.png',
        userId: seedUsers.UserForRandomArcs.id,
      },
      EbookAndAudioBook: {
        id: this.getNextId(),
        name: 'Pen name EbookAndAudioBook',
        image: 'test.png',
        userId: seedUsers.EbookAndAudioBook.id,
      },
      DueForTooLong: {
        id: this.getNextId(),
        name: 'Pen name DueForTooLong',
        image: 'test.png',
        userId: seedUsers.Me.id,
      },
      ArcForSameBook: {
        id: this.getNextId(),
        name: 'Arc for same book pen name',
        image: 'test.png',
        userId: seedUsers.ArcForSameBook.id
      },
      ArcTeamRestrictions: {
        id: this.getNextId(),
        name: 'Arc team restrictions pen name',
        image: 'test.png',
        userId: seedUsers.ArcTeamRestrictions.id
      },
      ReviewTranslationPenName: {
        id: this.getNextId(),
        name: 'Review Translation Pen Name',
        image: 'test.png',
        userId: seedUsers.ReviewTranslationAuthor.id,
        facebookLink: 'https://www.facebook.com',
        websiteLink: 'https://example.com/review-translation'
      },
      // sc-26587: pen name for the saved review copies email scenarios.
      SavedArcAuthor: {
        id: this.getNextId(),
        name: 'Saved-Arc Test Pen Name',
        image: 'test.png',
        userId: seedUsers.SavedArcAuthor.id
      },
      // sc-29038: pen name for the capped publisher's books.
      CappedPublisher: {
        id: this.getNextId(),
        name: 'Capped Publisher Pen Name',
        image: 'test.png',
        userId: seedUsers.CappedPublisher.id
      }
    }

    return testData
  }
}
